<!-- optional if you want some button at the top -->
<vdr-page-block>
    <vdr-action-bar>
        <vdr-ab-left></vdr-ab-left>
        <vdr-ab-right>
            <!-- *vdrIfPermissions="'CreateStoreSite'" -->
            <button class="btn btn-primary" (click)="openCreateDialog()" *ngIf="canCreateStoreSite$ | async" [disabled]="isCreatingStoreSite">
                <clr-icon shape="plus"></clr-icon>
                <span>{{ isCreatingStoreSite ? 'Creating…' : 'Create Store' }}</span>
                <clr-spinner *ngIf="isCreatingStoreSite" clrInline clrSmall style="margin-left: 0.5rem;"></clr-spinner>
            </button>
        </vdr-ab-right>
    </vdr-action-bar>
</vdr-page-block>

<vdr-data-table-2 id="store-site-list" [items]="items$ | async" [itemsPerPage]="itemsPerPage$ | async"
    [totalItems]="totalItems$ | async" [currentPage]="currentPage$ | async" [filters]="filters"
    (pageChange)="setPageNumber($event)" (itemsPerPageChange)="setItemsPerPage($event)">
    <!-- optional if you want to support bulk actions -->
    <vdr-bulk-action-menu locationId="store-site-list" [hostComponent]="this" [selectionManager]="selectionManager" />

    <!-- Adds a search bar -->
    <vdr-dt2-search [searchTermControl]="searchTermControl" searchTermPlaceholder="Filter by store name" />

    <!-- Here we define all the available columns -->
    <vdr-dt2-column [heading]="'common.id' | translate" id="id" [hiddenByDefault]="true">
        <ng-template let-storesite="item">{{ storesite.id }}</ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column [heading]="'common.created-at' | translate" id="created-at" [hiddenByDefault]="true"
        [sort]="sorts.get('createdAt')">
        <ng-template let-storesite="item">
            {{ storesite.createdAt | localeDate : 'short' }}
        </ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column [heading]="'common.updated-at' | translate" id="updated-at" [hiddenByDefault]="true"
        [sort]="sorts.get('updatedAt')">
        <ng-template let-storesite="item">
            {{ storesite.updatedAt | localeDate : 'short' }}
        </ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column heading="name" [sort]="sorts.get('name')">
        <ng-template let-storesite="item">
            <a class="button-ghost" (click)="switchStoreSite($event, storesite.id, storesite.sellerChannel?.id)">
                <span>{{ storesite.name }}</span>
                <clr-icon shape="arrow right"></clr-icon>
            </a>
        </ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column heading="Store URL" [optional]="false">
        <ng-template let-storesite="item">
            <a class="button-ghost" [href]="storesite.storeUrl" target="_blank">
                <span>{{ storesite.storeUrl }}</span>
                <clr-icon shape="pop-out"></clr-icon>
            </a>
        </ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column heading="Status" id="status" [optional]="false">
        <ng-template let-storesite="item">
            <vdr-chip [colorType]="getStatusColor(storesite)">
                {{ getStatusLabel(storesite) }}
            </vdr-chip>
        </ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column heading="Actions" [optional]="true">
        <ng-template let-storesite="item">
            <vdr-dropdown>
                <button class="icon-button" vdrDropdownTrigger>
                    <clr-icon shape="ellipsis-vertical"></clr-icon>
                </button>
                <vdr-dropdown-menu vdrPosition="bottom-right">
                    <button type="button" vdrDropdownItem (click)="openDetailPage(storesite)"
                        *vdrIfPermissions="['ReadSite']">
                        <clr-icon shape="settings"></clr-icon>
                        Settings
                    </button>
                    <button type="button" vdrDropdownItem (click)="openDuplicateDialog(storesite)" [hidden]="true"
                        *vdrIfPermissions="['CreateSite']">
                        <clr-icon shape="copy"></clr-icon>
                        Duplicate
                    </button>
                    <button type="button" class="delete-button" vdrDropdownItem
                        [disabled]="!(canArchive(storesite) | async)" *vdrIfPermissions="['DeleteSite']"
                        (click)="confirmArchiveStoreSite(storesite)">
                        <clr-icon shape="archive"></clr-icon>
                        Archive
                    </button>
                </vdr-dropdown-menu>
            </vdr-dropdown>
        </ng-template>
    </vdr-dt2-column>
</vdr-data-table-2>